import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomLineChart from "../../../../Common/Components/Charts/LineChart";
import CircularProgress from "../../../../Common/Components/CircularLoader";
import axiosMain from "../../../../http/axiosMain";

const reachLineChartData = [
  { name: "Shorts", key: "shorts", fill: "#68E484" },
  { name: "Videos", key: "videos", fill: "#68C8E4" },
  { name: "Live Streams", key: "liveStreams", fill: "#E45787" },
];

const TotalReach = () => {
  const [totalReachLoading, setTotalReachLoading] = useState(true);
  const [totalReachInsights, setTotalReachInsights] = useState([]);

  const getYoutubeTotalReach = async () => {
    try {
      setTotalReachLoading(true);
      const resp = await axiosMain.get("api/v1/insights/youtube-total-reach");
      if (resp.status === 200 && resp.data?.success) {
        setTotalReachInsights(resp.data?.data || []);
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setTotalReachLoading(false);
    }
  };

  useEffect(() => {
    getYoutubeTotalReach();
  }, []);

  return (
    <div className="youtube-container">
      <div className="options-content">
        <span className="platformtitle card-title">
          Total Reach of the Brand on youtube
        </span>
        <div className="right-top-actions">
          <span> weekly reach </span>
          <ExpandMoreRoundedIcon sx={{ width: "20px" }} />
        </div>
      </div>
      <div
        className="mt-4 flex"
        style={{
          marginTop: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!totalReachLoading && totalReachInsights?.length ? (
          <CustomLineChart
            data={totalReachInsights || []}
            lines={reachLineChartData}
            width={1000}
            height={332}
          />
        ) : totalReachLoading ? (
          <CircularProgress containerStyle={{ minWidth: "332px" }} />
        ) : (
          <div className="no-data">
            <small>No Data Found.</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalReach;
